module.exports = __webpack_public_path__ + "img/building95-6.f15d32ff.jpg";